module.exports = __webpack_public_path__ + "img/70_44.b529c4f8.png";